// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FOOTER_DOWNLOAD_ON_APP_STORE = "Stiahni z App Store";
export const INSTALL_PROMPT_DESCRIPTION = "Pridaj si ikonku Modr\u00e9ho kon\u00edka na plochu mobilu";
export const INSTALL_PROMPT_DOWNLOAD_APP = "Pridaj";
